export default {
  siteName: 'Nordatec',
  copyright: 'Nordatec Smart Energy',
  logoPath: 'logo-small.png',
  fixedHeader: true, // sticky primary layout header
  defaultTitle: 'BMS-3000',
  /* I18n configuration, `languages` and `defaultLanguage` are required currently. */
  i18n: {
    /* Countrys flags: https://www.flaticon.com/packs/countrys-flags */
    languages: [
      {
        key: 'en',
        title: 'English',
        flag: '/america.svg'
      }
    ],
    defaultLanguage: 'en'
  }
};
